import * as React from "react";

import cn from "classnames";

import { DropdownContext } from "./DropdownProvider";

/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
export const DropdownInputContainer = (props: React.PropsWithChildren<any>) => {
    const { children } = props;

    const {
        classes, comboBoxProps, invalidInput, focusInput
    } = React.useContext(DropdownContext);

    const inputContainerClassNames = cn(
        classes?.inputContainer,
        invalidInput ? classes?.inputContainerError : null
    );

    return (
        <div className={inputContainerClassNames} {...comboBoxProps} onClick={focusInput}>
            {children}
        </div>
    );
};
